import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanDeactivate,
} from "@angular/router";
import { SessionStorageService, LocalStorageService } from "ngx-webstorage";
import { CommonService } from "../common/common.service";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";
import { environment } from "../../environments/environment";
import { AuthService } from "../auth/auth.service";

@Injectable()
export class AuthGuardMain implements CanActivate {
  constructor(
    private router: Router,
    private sessionStorageService: SessionStorageService,
    private common: CommonService,
    private authService: AuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Allow public informational pages and activation link without authentication
    const publicRoutes = [
      "/terms-conditions",
      "/privacy-policy",
      "/activationlink",
    ];
    const urlPath = state.url.split("?")[0]; // Remove query params
    if (
      publicRoutes.some(
        (publicRoute) =>
          urlPath === publicRoute || urlPath.startsWith(publicRoute + "/")
      )
    ) {
      return true;
    }

    // if (Object.keys(this.common.getUserInfo()).length)
    //   this.sessionStorageService.store('userInfo', this.common.getUserInfo());
    try {
      if (Object.keys(this.common.getUserInfo()).length) {
        // logged in so return true
        return true;
      }

      const storedUserInfo = this.common.getStorage(
        this.common.loginConst.userInfoObj
      );
      if (storedUserInfo && Object.keys(storedUserInfo).length) {
        this.authService.userInfo = this.common.updateAccessInfo(storedUserInfo);
        return true;
      }
    } catch (e) {
      // If getUserInfo fails, allow public routes
      if (
        publicRoutes.some(
          (publicRoute) =>
            urlPath === publicRoute || urlPath.startsWith(publicRoute + "/")
        )
      ) {
        return true;
      }
    }
    // not logged in so redirect to login page with the return url
    this.router.navigate(["/auth/login"]);
    return false;
  }
}

@Injectable()
export class AuthGuardLogin implements CanActivate {
  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private sessionStorageService: SessionStorageService,
    private common: CommonService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const urlPath = state.url.split("?")[0];
    // Allow activation link, privacy policy, and terms and conditions without auth
    if (urlPath === "/activationlink" || 
        urlPath === "/privacy-policy" || 
        urlPath === "/terms-conditions") {
      return true;
    }

    // if (Object.keys(this.common.getUserInfo()).length)
    // this.sessionStorageService.store('userInfo', this.localStorageService.retrieve('userInfo'));
    if (Object.keys(this.common.getUserInfo()).length) {
      // logged in so return true
      this.router.navigate(environment.OPEN_MODULE);
      return false;
    }

    return true;
  }
}

@Injectable()
export class ModuleAccessGuard implements CanActivate {
  constructor(private router: Router, private common: CommonService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let userInfo = this.common.getUserInfo();
    let lowerUserInfoObj = _.transform(userInfo, function (result, val, key) {
      result[key.toLowerCase()] = val;
    });
    let fString = state.url.substring(6, state.url.length);
    let sString = "";
    if (fString.indexOf("/") != -1) {
      sString = fString.substring(0, fString.indexOf("/"));
    } else {
      sString = fString;
    }
    function camelize(str) {
      return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
          return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
        })
        .replace(/\s+/g, "");
    }
    let moduleName = camelize(sString.replace(/-/g, ""));
    if (lowerUserInfoObj[moduleName] == "H") {
      let path = this.common.getModulePath();
      this.router.navigate(path);
      return false;
    }
    return true;
  }
}

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard
  implements CanDeactivate<CanComponentDeactivate>
{
  constructor(private router: Router) {}

  nextUrl = false;

  promoCheck(component, url) {
    if (
      component["step1"]["dirty"] &&
      !component["disablePromo"] &&
      !this.nextUrl
    ) {
      component["createPromoService"]["cancelAlert"](() => {
        this.nextUrl = true;
        this.router.navigate([url]);
      });
    } else {
      this.nextUrl = false;
      return true;
    }
  }
  sgmCheck(component, url) {
    if (
      (component["serviceGroup"]["serviceGroupName"] ||
        component["serviceGroup"]["serviceGroupDesc"]) &&
      !component["disableSGM"] &&
      !this.nextUrl &&
      !component["isSubmit"]
    ) {
      component["serviceGroupManagementService"]["cancelAlert"](() => {
        this.nextUrl = true;
        this.router.navigate([url]);
      });
    } else {
      this.nextUrl = false;
      return true;
    }
  }
  wmCheck(component, url) {
    if (
      component["entityWallet"] &&
      component["entityWallet"]["createWalletForm"]["dirty"] &&
      !this.nextUrl &&
      !component["entityWallet"]["isSubmitted"]
    ) {
      component["entityWallet"]["service"]["cancelAlertWallet"](() => {
        this.nextUrl = true;
        this.router.navigate([url]);
      });
    } else if (
      component["dcWalletForm"] &&
      !this.nextUrl &&
      !component["isSubmitted"] &&
      (component["dcWalletForm"]["dirty"] ||
        component["entityTypeSource"] ||
        component["entityTypeBenef"])
    ) {
      component["service"]["cancelAlertWallet"](() => {
        this.nextUrl = true;
        this.router.navigate([url]);
      });
    } else {
      this.nextUrl = false;
      return true;
    }
  }
  canDeactivate(component: CanComponentDeactivate, route, state, nextUrl) {
    if (component["createPromoService"]) {
    } else if (component["serviceGroupManagementService"]) {
      return this.sgmCheck(component, nextUrl["url"]);
    } else if (component["entityWallet"] || component["dcWalletForm"]) {
      return this.wmCheck(component, nextUrl["url"]);
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/guards/auth.guard.ts